import { render, staticRenderFns } from "./ViewAppAdminApps.vue?vue&type=template&id=c5490dc0&scoped=true&"
import script from "./ViewAppAdminApps.vue?vue&type=script&lang=js&"
export * from "./ViewAppAdminApps.vue?vue&type=script&lang=js&"
import style0 from "./ViewAppAdminApps.vue?vue&type=style&index=0&id=c5490dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5490dc0",
  null
  
)

export default component.exports